module.exports = __webpack_public_path__ + "media/sampleDetail.2018055c.mp4";